import React, { useEffect, useState, useCallback } from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardBody,
  Container,
  Form,
  FormFeedback,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Col,
  Spinner
} from "reactstrap";

import * as Yup from "yup";
import { useFormik } from "formik";
import moment from 'moment';
import 'moment-timezone';

import parse from "html-react-parser";
import ModalImage from "react-modal-image";
import Select from "react-select";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin, { Draggable } from "@fullcalendar/interaction";
import BootstrapTheme from "@fullcalendar/bootstrap";
import Flatpickr from "react-flatpickr";
import handleValidDate from "../../../helpers/utils/handleValidDate";
import Fullscreen from 'react-fullscreen-crossbrowser';

//redux
import { useSelector, useDispatch } from "react-redux";

import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";

import logo from "../../../assets/images/logo-sm.png";
import ModalInputFile from "../../../Components/ModalInputFile";
import { api } from "../../../config";

//Simple bar
import SimpleBar from "simplebar-react";
import UpcommingEvents from './UpcommingEvents';
import listPlugin from '@fullcalendar/list';

import { isDate, isEmpty } from "lodash";
import { getCivilBudget, resetCivilBudgetState } from "../../../store/civilBudget/action";
import { getCivilProgression, resetCivilProgressionState } from "../../../store/civilProgression/action";
import { resetProductVarianState, getProductVarian } from "../../../store/productVarian/action";
import { getBranch, resetBranchState } from "../../../store/branch/action";
import { getClient, resetClientState } from "../../../store/client/action";
import { resetCompanyState, getCompany } from "../../../store/company/action";
import { getEmployee, resetEmployeeState } from "../../../store/employee/action";
import { getDashboard, resetDashboardState } from "../../../store/dashboard/action";
import {
  getEvents as onGetEvents,
  getCategories as onGetCategories,
  addNewEvent as onAddNewEvent,
  deleteEvent as onDeleteEvent,
  updateEvent as onUpdateEvent,
  resetCalendar,
} from "../../../store/calendar/action";

const Calender = () => {
  const dispatch = useDispatch();
  const [event, setEvent] = useState({});
  const [modal, setModal] = useState(false);
  const [modalFull, setModalFull] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [approveModal, setApproveModal] = useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [isTask, setIsTask] = useState(false);
  const [upcommingevents, setUpcommingevents] = useState([]);
  const [timeoff, setTimeOff] = useState([]);
  const [overtime, setOvertime] = useState([]);
  const [otherEvent, setOtherEvent] = useState([]);
  const [allEvent, setAllevent] = useState([]);
  const [eventList, setEventList] = useState([]);
  const [dragData, setDragData] = useState(false);
  const [isShowEventForm, setIsShowEventForm] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [modalMedia, setModalMedia] = useState(false);
  const [taskFiles, setTaskFiles] = useState([]);
  const [isSearch, setIsSearch] = useState(false);

  const [userRole, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [userData, setUserData] = useState(null);
  const [clientSelected, setClientSelect] = useState(null);
  const [companySelected, setCompanySelect] = useState(null);
  const [employeeSelect, setEmployeeSelect] = useState(null);
  const [positionMessage, setPositionMessage] = useState("");
  const [defaultCompanyId, setDefaultCompanyId] = useState(null);

  const [isCaseProgress, setIsCaseProgress] = useState(false);
  const [isRincikProgress, setIsRincikProgress] = useState(false);
  const [info, setInfo] = useState([]);
  const [svg, setSVG] = useState("");
  const [branchList, setBranchList] = useState([]);
  const [civilBudgetList, setCivilBudgetList] = useState(null);
  const [branchSelected, setBranchSelect] = useState(null);
  const [productList, setProductList] = useState([]);
  const [progressList, setProgressList] = useState([]);
  const [isFullscreenMap, setIsFullscreenMap] = useState(false);
  const [progressUnitList, setProgressUnitList] = useState([]);
  const [progressBlokList, setProgressBlockList] = useState([]);
  const [locationCord, setLocationCord] = useState([-6.4577368, 106.9776222]);
  const [mapHeight, setMapHeight] = useState("750px");
  const [assetList, setAssetList] = useState([]);
  const [schedule, setSchedule] = useState([]);
  const [scheduleDetail, setScheduleDetail] = useState([]);
  const [civilBudgetSelectList, setCivilBudgetSelectList] = useState([]);
  const [civilBudget, setCivilBudget] = useState([]);
  const [branchName, setBranchName] = useState("");
  const [startAt, setStartAt] = useState("");
  const [endAt, setEndAt] = useState("");
  const [unit, setUnit] = useState(0);
  const [budgetName, setBudgetName] = useState("");

  const { events, loading, categories, isEventUpdated, isEventLoaded, employees, employeeLoading, dashboards, dashboardLoading,
    clients, clientLoading, companies, companyLoading, branches, branchLoading, productVarians, productVarianLoading,
    civilBudgets, civilBudgetLoading, civilProgressions, civilProgressionLoading, civilBudgetSchedules, civilBudgetScheduleLoading, } = useSelector((state) => ({
      events: state.Calendar.events,
      loading: state.Calendar.loading,
      categories: state.Calendar.categories,
      isEventUpdated: state.Calendar.isEventUpdated,
      isEventLoaded: state.Calendar.isEventLoaded,
      employees: state.Employee.employees,
      employeeLoading: state.Employee.loading,
      clients: state.Client.clients,
      clientLoading: state.Client.loading,
      companies: state.Company.companies,
      companyLoading: state.Company.loading,
      branches: state.Branch.branches,
      branchLoading: state.Branch.loading,
      productVarians: state.ProductVarian.productVarians,
      productVarianLoading: state.ProductVarian.loading,
      civilBudgets: state.CivilBudget.civilBudgets,
      civilBudgetLoading: state.CivilBudget.loading,
      civilProgressions: state.CivilProgression.civilProgressions,
      civilProgressionLoading: state.CivilProgression.loading,
      civilBudgetSchedules: state.CivilBudgetSchedule.civilBudgetSchedules,
      civilBudgetScheduleLoading: state.CivilBudgetSchedule.loading,
      dashboards: state.Dashboard.dashboards,
      dashboardLoading: state.Dashboard.loading,
    }));

  useEffect(() => {
    if (!isSearch) {
      setIsEdit(false);
      setIsSearch(true);
      dispatch(resetCalendar());
      const obj = JSON.parse(localStorage.getItem("authUser"));
      if (obj?.data) {
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method && obj?.data?.user?.user_position?.position_role.method);
        setUserData(obj.data);
        setUserType(obj?.data?.userType);
        setRoles(obj?.data?.user?.user_position && obj?.data?.user?.user_position?.position_role && obj?.data?.user?.user_position?.position_role.method);
        setPositionMessage(`${obj?.data?.user?.user_department && obj?.data?.user?.user_department?.name}, ${obj?.data?.user?.user_position && obj?.data?.user?.user_position?.name}`)
        setClientSelect({
          label: obj.data.client_name,
          value: obj.data.clientId
        });
        setCompanySelect({
          label: obj.data.company_name,
          value: obj.data.companyId
        });
        setEmployeeSelect({
          label: obj?.data?.user.name,
          value: obj?.data?.userId
        });

        dispatch(onGetEvents());
        dispatch(onGetCategories());
        dispatch(resetClientState());
        dispatch(getClient());
        handleGetCompany(obj.data.clientId);
        handleGetEmployee(obj.data.companyId);

        dispatch(resetCivilBudgetState());
        dispatch(resetCivilProgressionState());
        dispatch(resetProductVarianState());
        dispatch(resetBranchState());
        dispatch(getBranch({ status: 2, visible: true, svg: true }));

      }
    }
  }, [dispatch, isSearch]);

  useEffect(() => {
    setProductList(productVarians);
  }, [productVarians]);

  useEffect(() => {
    if (!isEmpty(branches)) {
      var data = [];
      var opt = [];
      (branches || []).forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, companyId: item.companyId, svg_siteplan: item.svg_siteplan, svg_rincik: item.svg_rincik, branch_code: item.branch_code };
        opt.push(obj);
        if (id === 1) {
          handleGetDefault(item.companyId, id, item.svg_siteplan, item.svg_rincik,);
          setBranchSelect(obj);
        }
      });
      var option = { options: opt.sort((a, b) => (a.label ?? "").localeCompare((b.label ?? ""), undefined, { numeric: true, sensitivity: 'base' })) };
      data.push(option);
      setBranchList(data);
    }
  }, [branches, companySelected]);

  useEffect(() => {
    new Draggable(document.getElementById("external-events"), {
      itemSelector: ".external-event",
    });
  }, []);

  useEffect(() => {
    setUpcommingevents(events);
    upcommingevents.sort(function (o1, o2) {
      return new Date(o1.start) - new Date(o2.start);
    });

  }, [events, upcommingevents]);

  const handleGetCompany = (id) => {
    dispatch(resetCompanyState());
    dispatch(resetEmployeeState());
    validation.setFieldValue("employee", {})
    setEmployeeList([]);
    dispatch(getCompany({ clientId: id }));
  };

  const handleGetProductVariant = (companyId, branchId, type) => {
    dispatch(resetProductVarianState());
    dispatch(getProductVarian({ companyId: companyId, branchId: branchId, type: type, status: 2 }));
  }

  const handleGetBranch = (id) => {
    dispatch(resetBranchState());
    dispatch(getBranch({ companyId: id, status: 2, visible: true, svg: true }));
  };

  const handleCivilBudget = (id, branchId, type) => {
    dispatch(resetCivilBudgetState());
    dispatch(getCivilBudget({ companyId: id, branchId: branchId, type: type }));
  };

  const handleCivilProgression = (id, product) => {
    dispatch(resetCivilProgressionState());
    dispatch(getCivilProgression({ companyId: id, productId: product }));
  };

  useEffect(() => {
    var list = [];
    var data = [];
    var opt = [];
    civilBudgets.forEach((it, idx) => {
      const name = it.cvl_branch ? it.cvl_branch.name + ' - ' + it.name : it.name;
      const id = it.id;
      if (it.cvl_branch.id === 1 && companySelected && companySelected.value && it) {
        setCivilBudget({ label: name, value: id, data: it });
      }
      var obj = { label: name, value: id, data: it };
      opt.push(obj);
      (it.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order) || []).forEach((item, key) => {
        let cat = item.cvld_account && item.cvld_account.cvl_account_category ? item.cvld_account.cvl_account_category.name : "";
        let findCategory = list.find(x => x.category === cat);
        if (findCategory) {
          findCategory.data.push(item);
        }
        else {
          list.push({ category: cat, data: [item] })
        }
      });
    });
    setCivilBudgetList(list);

    var option = { options: opt };
    data.push(option);
    setCivilBudgetSelectList(data);
  }, [civilBudgets]);

  const handleGetDefault = (companyId, branchId, svg) => {
    dispatch(resetDashboardState());
    dispatch(getDashboard({ branchId: branchId, companyId: companyId }));
    handleCivilBudget(companyId, branchId, "PROGRESS BANGUNAN");
    handleGetProductVariant(companyId, branchId, 1);
    setSVG(svg);

  };

  useEffect(() => {
    let arrProgress = [];
    let arrProgressBlock = [];
    let arrBlok = [];
    for (const varian of productList) {
      let block = varian.pvar_product.product_block ? varian.pvar_product.product_block.name : "";
      let name = varian.pvar_product.name;
      let prod = block + "-" + name;
      let progress = dashboards.civil_progress ? dashboards.civil_progress : [];
      let weight = 0;

      let findBlok = arrBlok.find(x => x.block === block);
      if (!findBlok) {
        arrBlok.push({ block: block, weight: 0 })
      }

      for (const detail of progress.sort((a, b) => a.id - b.id)) {
        let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
        let blok = detail.cvlp_product && detail.cvlp_product.product_block && detail.cvlp_product.product_block.name;
        let unit = detail.cvlp_product && detail.cvlp_product.name;
        let key = blok + "-" + unit;
        if (prod === key) {
          for (const acc of civilBudgets) {
            for (const account of acc.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
              let findCategory = m.indexOf(account.cvld_account.id.toString());
              if (findCategory !== -1)
                weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
            }
          }
        }
      }
      arrProgress.push({
        name: prod,
        block: block,
        weight: weight.toFixed(2)
      });
    }
    setProgressUnitList(arrProgress.sort((a, b) => b.name === a.name ? 0 : a.name > b.name ? 1 : -1));

    arrProgress = [];
    for (const varian of arrBlok) {
      let block = varian.block ? varian.block : "";
      let weight = 0;
      let progress = dashboards.civil_progress ? dashboards.civil_progress : [];

      for (const detail of progress.sort((a, b) => a.id - b.id)) {
        let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
        let blok = detail.cvlp_product && detail.cvlp_product.product_block && detail.cvlp_product.product_block.name;
        if (block === blok) {
          for (const acc of civilBudgets) {
            for (const account of acc.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
              let findCategory = m.indexOf(account.cvld_account.id.toString());
              if (findCategory !== -1)
                weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
            }
          }
        }
      }
      arrProgressBlock.push({
        block: block,
        weight: weight.toFixed(2)
      });
    }
    setProgressBlockList(arrProgressBlock.sort((a, b) => {
      a = a.block.replace(/(\d+)(.)/, '$2$1')
      b = b.block.replace(/(\d+)(.)/, '$2$1')
      return a.localeCompare(b, 'en', { numeric: true })
    }));

  }, [dashboards, civilBudgets, productList]);

  useEffect(() => {
    if (!civilBudgetLoading && !loading && !productVarianLoading) {
      for (const varian of productList) {
        let block = varian.pvar_product.product_block ? varian.pvar_product.product_block.name : "";
        let name = varian.pvar_product.name;
        let ele = document.getElementById(block + "-" + name);
        if (ele) {
          ele.removeAttribute("class");
          ele.style.fill = "#FFFFFF";
        }
      }

      let arrProgress = [];
      let progress = dashboards.civil_progress ? dashboards.civil_progress : [];
      for (const detail of progress.sort((a, b) => a.id - b.id)) {
        let m = detail.checked_progress ? detail.checked_progress.split(",") : [];
        let blok = detail.cvlp_product && detail.cvlp_product.product_block && detail.cvlp_product.product_block.name;
        let category = detail.cvlp_product && detail.cvlp_product.product_category && detail.cvlp_product.product_category.name;
        let unit = detail.cvlp_product && detail.cvlp_product.name;
        let image = detail.cvlp_product && detail.cvlp_product.image ? `${api.MEDIA_URL}/media/${detail.cvlp_product.image}-w-150` : logo;
        let key = blok + "-" + unit;
        detail.key = key;
        detail.name = category + " - " + key;
        detail.image = image;
        let weight = 0;
        for (const acc of civilBudgets) {
          for (const account of acc.cvl_detail.sort((a, b) => a.cvld_account && b.cvld_account && a.cvld_account.sort_order - b.cvld_account.sort_order)) {
            let findCategory = m.indexOf(account.cvld_account.id.toString());
            if (findCategory !== -1) {
              weight += !isNaN(parseFloat(account.weight)) ? parseFloat(account.weight) : 0;
              let ele = document.getElementById(blok + "-" + unit);
              detail.progress = account.cvld_account.name;
              detail.color = account.cvld_account.color;
              if (ele) {
                ele.removeAttribute("class");
                ele.style.fill = account.cvld_account.color;
              }

            }
          }
        }
        detail.weight = weight.toFixed(2);
        arrProgress.push(detail);
      }
      setProgressList(arrProgress);
    }
  }, [svg, dashboards, civilBudgets, civilBudgetLoading, productList, productVarianLoading]);

  useEffect(() => {
    document.body.addEventListener('click', (element) => {
      if (element.target.id) {
        let data = progressList.find(x => x.key === element.target.id);
        if (data) {
          handleCivilProgression(data.companyId, data.productId);
          setInfo(data);
          toggleFull();
        }
      }
    });

    document.body.addEventListener('mouseover', (element) => {
      if (element.target.id) {
        let data = progressList.find(x => x.key === element.target.id);
        if (data) {
          setInfo(data);
          var iconPos = document.querySelector("#" + data.key).getBoundingClientRect();
          var mypopup = document.getElementById("dashboard-custom-tooltip");
          mypopup.style.left = iconPos.right < 1000 ? (iconPos.right + 10) + "px" : ((iconPos.right - 460) + 10) + "px";
          mypopup.style.top = (window.scrollY + iconPos.top - 60) + "px";
          mypopup.style.display = "block";
        }
      }
    });

    document.body.addEventListener('mouseout', (element) => {
      if (element.target.id) {
        let data = progressList.find(x => x.key === element.target.id);
        if (data) {
          var mypopup = document.getElementById("dashboard-custom-tooltip");
          mypopup.style.display = "none";
        }
      }
    });
  }, [progressList]);

  const [initialPosition, setInitialPosition] = useState([0, 0]);
  const [selectedPosition, setSelectedPosition] = useState([0, 0]);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(position => {
      const { latitude, longitude } = position.coords;
      setInitialPosition([latitude, longitude]);

    });
  }, []);

  const handleGetEmployee = (id) => {
    dispatch(resetEmployeeState());
    dispatch(getEmployee({ companyId: id }));
  };

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  const handleDeleteFile = (file) => {
    if (isEdit) {
      const newState = taskFiles.map((obj) => {
        if (obj.filename === file.filename) {
          return { filename: file.filename, isDeleted: true };
        }
        return obj;
      });
      setTaskFiles(newState);
    } else {
      const index = taskFiles.findIndex((fl) => fl.filename === file.filename);
      setTaskFiles((val) => [...val.slice(0, index), ...val.slice(index + 1)]);
    }
  };

  useEffect(() => {
    var data = [];
    var opt = [];
    (companies || []).forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      var obj = { label: name, value: id };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (companies.length > 0) {
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    var data = [];
    var opt = [];
    employees.forEach((item, key) => {
      const name = item.name;
      const id = item.userId;
      const position = item?.employee_user?.user_position && item?.employee_user?.user_department ? { label: `${item?.employee_user?.user_position?.name}, ${item?.employee_user?.user_department?.name}`, value: item?.employee_user?.user_position?.id, departmentId: item?.employee_user?.user_department?.id } : "";
      var obj = { label: name, value: id, position: position };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (employees.length > 0) {
      setEmployeeList(data);
    }
  }, [employees]);

  useEffect(() => {
    if (isEventUpdated) {
      setIsEdit(false);
      setIsShowEventForm(false);
      setEvent({});
      dispatch(resetCalendar("isEventUpdated", false));
    }
  }, [dispatch, isEventUpdated]);

  useEffect(() => {
    if (!isEmpty(categories)) {
      var dataTimeoff = [];
      var dataOvertime = [];
      var dataOther = [];
      var dataAll = [];
      var optTimeoff = [];
      var optOvertime = [];
      var optOther = [];
      var optAll = [];
      categories.data.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        if (item.type !== 'attendance') {
          optAll.push(obj);
        }

        if (item.type === 'timeoff') {
          optTimeoff.push(obj);
        }
        else if (item.type === 'overtime') {
          optOvertime.push(obj);
        }
        else if (item.type === 'general') {
          optOther.push(obj);
        }
      });

      dataTimeoff.push({ options: optTimeoff });
      setTimeOff(dataTimeoff);
      dataOvertime.push({ options: optOvertime });
      setOvertime(dataOvertime);
      dataOther.push({ options: optOther });
      setOtherEvent(dataOther);
      dataAll.push({ options: optAll });
      setAllevent(dataAll);
      setEventList(dataAll);
    }
  }, [categories]);

  const toggleMedia = useCallback(() => {
    if (modalMedia) {
      setModalMedia(false);
    } else {
      setModalMedia(true);
    }
  }, [modalMedia]);

  const toggleFull = () => {
    if (modalFull) {
      setModalFull(false);
      setDragData([]);
      setEventList(allEvent);
    } else {
      setModalFull(true);
    }
  };

  const toggle = () => {
    if (modal) {
      setModal(false);
      setEvent(null);
      setIsEdit(false);
      setIsTask(false);
      setIsShowEventForm(false);
      setDragData([]);
      setEventList(allEvent);
    } else {
      setModal(true);
    }
  };

  const handleSelectFile = (file) => {
    setTaskFiles((val) => [...val, { filename: file.filename, originalname: file.originalname }]);
    toggleMedia();
  };

  const handleApproveEmployee = () => {
    if (event) {
      event.setApprove = true;
      event.canApprove = false;
      dispatch(onUpdateEvent(event));
      setApproveModal(false);
      setModal(false)
    }
  };

  const handleDateClick = (arg) => {
    const date = arg["date"];
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    const currectDate = new Date();
    const currentHour = currectDate.getHours();
    const currentMin = currectDate.getMinutes();
    const currentSec = currectDate.getSeconds();
    const modifiedDate = new Date(year, month, day, currentHour, currentMin, currentSec);

    const modifiedData = { ...arg, date: modifiedDate };
    validation.setFieldValue("startat", modifiedDate);
    setDragData(modifiedData);
    toggle();
  };

  const handleEventClick = (arg) => {
    const event = arg.event;
    let files = [];
    if (event.extendedProps.permission_category) {
      if (event.extendedProps.permission_category) {
        let files = [];
        for (const f of event.extendedProps.permission_file) {
          files.push({ filename: f.filename, originalname: f.originalname })
        }
        setTaskFiles(files);

        setEvent({
          client:
            event.extendedProps.permission_client && {
              label: event.extendedProps.permission_client ? event.extendedProps.permission_client.name : "",
              value: event.extendedProps.permission_client ? event.extendedProps.permission_client.id : "",
            },
          company:
            event.extendedProps.permission_company && {
              label: event.extendedProps.permission_company ? event.extendedProps.permission_company.name : "",
              value: event.extendedProps.permission_company ? event.extendedProps.permission_company.id : "",
            },
          id: event.extendedProps.id,
          title: event.title,
          name: event.extendedProps.name,
          permission_category: event.extendedProps.permission_category,
          startat: event.extendedProps.startat,
          endat: event.extendedProps.endat,
          className: event.extendedProps.permission_category.classname,
          type: { label: event.extendedProps.permission_category.name, value: event.extendedProps.permission_category.id, type: event.extendedProps.permission_category.type },
          description: event.extendedProps.description,
          location: event.extendedProps.location,
          path: event.extendedProps.permission_file,
          employee: { label: event.extendedProps.permission_user.name, value: event.extendedProps.permission_user.id, companyId: event.extendedProps.permission_user.companyId },
          canApprove: event.extendedProps.canApprove
        });
      }
      else {
        setEvent({
          client: "",
          company: "",
          id: event.extendedProps.id,
          title: event.title,
          name: event.extendedProps.name,
          permission_category: event.extendedProps.task_type,
          startat: event.extendedProps.startat,
          endat: event.extendedProps.endat,
          className: event.className,
          type: event.extendedProps.priority,
          description: event.extendedProps.description,
          location: "",
          path: "",
          employee: "",
          canApprove: ""
        });
        setIsTask(true);
      }
      setIsEdit(true);
      toggle();
    }
    else {
      document.getElementById("siteplan").classList.remove("d-none");
      setIsFullscreenMap(true);
    }
  };

  const handleDeleteEvent = () => {
    dispatch(onDeleteEvent(event));
    setDeleteModal(false);
    toggle();
  };

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      client: (event && event.client) || clientSelected,
      company: (event && event.company) || companySelected,
      name: (event && event.name) ?? "",
      location: (event && event.location) ?? "",
      description: (event && event.description) ?? "",
      startat: (event && event.startat) ?? "",
      endat: (event && event.endat) ?? "",
      type: (event && event.type),
      employee: (event && event.employee) || employeeSelect,
    },

    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Your Event Name"),
      startat: Yup.string().required("Please Enter Your Event Start Date"),
      endat: Yup.string().required("Please Enter Your Event End Date"),
      type: Yup.object().required("Please Select Your Category"),
    }),
    onSubmit: (values) => {
      if (isEdit) {
        let newTask = {
          id: event ? event.id : 0,
          permissionCategoryId: values.type.value,
          startat: values.startat,
          endat: values.endat,
          description: values.description,
          location: values.location,
          name: values.name,
          clientId: values.client.value,
          companyId: values.company.value,
          userId: values.employee.value,
          files: taskFiles.length > 0 ? taskFiles : [],
        };
        dispatch(onUpdateEvent(newTask));
        validation.resetForm();
      } else {
        let newTask = {
          permissionCategoryId: values.type.value,
          startat: values.startat,
          endat: values.endat,
          description: values.description,
          location: values.location,
          name: values.name,
          clientId: values.client.value,
          companyId: values.company.value,
          userId: values.employee.value,
          files: taskFiles.length > 0 ? taskFiles : [],
        };
        dispatch(onAddNewEvent(newTask));
        validation.resetForm();
      }
      toggle();
    },
  });

  const submitOtherEvent = () => {
    document.getElementById("form-event").classList.remove("view-event");
    document.getElementById("btn-save-event").removeAttribute("hidden");
  };

  const onDrag = (event) => {
    event.preventDefault();
  };

  const onDrop = (event) => {
    const date = event["date"];
    const day = date.getDate();
    const month = date.getMonth();
    const year = date.getFullYear();

    const currectDate = new Date();
    const currentHour = currectDate.getHours();
    const currentMin = currectDate.getMinutes();
    const currentSec = currectDate.getSeconds();
    const modifiedDate = new Date(year, month, day, currentHour, currentMin, currentSec);

    const draggedEl = event.draggedEl;
    const draggedElclass = draggedEl.className;
    if (draggedEl.classList.contains("external-event") && draggedElclass.indexOf("fc-event-draggable") === -1) {
      const modifiedData = {
        title: draggedEl.innerText,
        start: modifiedDate,
        className: draggedEl.className,
      };

      if (draggedEl.innerText === "Time Off Request") {
        setEventList(timeoff);
      }
      else if (draggedEl.innerText === "Overtime Request") {
        setEventList(overtime);
      }
      else {
        setEventList(otherEvent);
      }
      validation.setFieldValue("startat", modifiedDate);
      setDragData(modifiedData);
      toggle();
    }
  };

  function handleFileChange(event) {
    if (event.target.files && event.target.files[0]) {
      validation.setFieldValue("img", event.target.files[0]);
    }
  }

  function isDateGreater(dateToCheckString) {
    const dateToCheck = new Date(dateToCheckString);
    const startDate = new Date();

    if (isNaN(dateToCheck.getTime()) || isNaN(startDate.getTime())) {
      console.error("Invalid dateToCheck format provided.");
      return false;
    }

    return dateToCheck >= (startDate-86400000);
  }

  document.title = "Kalender | Enterprise Resources Planning";

  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteEvent}
        onCloseClick={() => setDeleteModal(false)} />
      <ApproveModal data={event && event.permission_user ? event.permission_user.name : ""} show={approveModal} onApproveClick={handleApproveEmployee} onCloseClick={() => setApproveModal(false)} />

      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Calendar" pageTitle="Apps" />
          <Row>
            <Col xs={12}>
              <Row>
                <Col xl={3}>
                  <Card className="card-h-100">
                    <CardBody>
                      <button className="btn btn-light w-100" id="btn-new-event" onClick={toggle}>
                        <i className="mdi mdi-plus"></i> Tambah Acara Baru
                      </button>

                      <div id="external-events">
                        <br />
                        <p className="text-muted"> Drag and drop your event or click in the calendar </p>
                        <div className={`bg-soft-danger external-event fc-event text-danger`}
                          key={1}
                          draggable
                          onDrag={(event) => {
                            onDrag(event, "timeoff");
                          }}><i className="mdi mdi-checkbox-blank-circle font-size-11 me-2" />Permintaan Cuti</div>

                        <div className={`bg-soft-warning external-event fc-event text-warning`}
                          key={2}
                          draggable
                          onDrag={(event) => {
                            onDrag(event, "overtime");
                          }}><i className="mdi mdi-checkbox-blank-circle font-size-11 me-2" />Permintaan Lembur</div>

                        <div className={`bg-soft-info external-event fc-event text-info`}
                          key={4}
                          draggable
                          onDrag={(event) => {
                            onDrag(event, "info");
                          }}><i className="mdi mdi-checkbox-blank-circle font-size-11 me-2" />Informasi Perusahaan</div>

                        <div className={`bg-soft-success external-event fc-event text-success`}
                          key={5}
                          draggable
                          onDrag={(event) => {
                            onDrag(event, "meeting");
                          }}><i className="mdi mdi-checkbox-blank-circle font-size-11 me-2" />Meeting</div>

                      </div>
                    </CardBody>
                  </Card>
                  <div>
                    <h5 className="mb-1">Agenda Yang Akan Datang</h5>
                    <p className="text-muted">Jangan lewatkan acara yang dijadwalkan</p>
                    <SimpleBar
                      className="pe-2 me-n1 mb-3"
                      style={{ height: "400px" }}>
                      <div id="upcoming-event-list">
                        {(upcommingevents || []).map((event, key) => (
                          isDateGreater(handleValidDate(event?.start, "YYYY/MM/DD"))) ? <React.Fragment key={key}>
                            <UpcommingEvents event={event} />
                          </React.Fragment> : null
                        )}
                      </div>
                    </SimpleBar>
                  </div>

                </Col>

                <Col xl={9}>
                  <Card className="card-h-100">
                    <CardBody>
                      <FullCalendar
                        plugins={[
                          BootstrapTheme,
                          dayGridPlugin,
                          interactionPlugin,
                          listPlugin
                        ]}
                        initialView="dayGridMonth"
                        slotDuration={"00:15:00"}
                        handleWindowResize={true}
                        themeSystem="bootstrap"
                        headerToolbar={{
                          left: "prev,next today",
                          center: "title",
                          right: "dayGridMonth,dayGridWeek,dayGridDay,listWeek",
                        }}
                        events={events}
                        editable={true}
                        droppable={true}
                        selectable={true}
                        dateClick={handleDateClick}
                        eventClick={handleEventClick}
                        drop={onDrop}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>

              <div style={{ clear: "both" }}></div>
              <Modal isOpen={modal} id="event-modal" centered size="lg">
                <ModalHeader toggle={toggle} tag="h5" className="p-3 bg-soft-info modal-title">
                  {!!isEdit ? "Edit Jadwal Kalender" : "Tambah Jadwal Kalender"}
                </ModalHeader>
                <ModalBody>
                  <Form className={!!isEdit ? "needs-validation view-event" : "needs-validation"}
                    name="event-form"
                    id="form-event"
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}>
                    <div className="event-details">
                      <div className="d-flex mb-2">
                        <div className="flex-grow-1 d-flex align-items-center">
                          <div className="flex-shrink-0 me-3">
                            <i className="ri-calendar-event-line text-muted fs-16"></i>
                          </div>
                          <div className="flex-grow-1">
                            <h6 className="d-block fw-semibold mb-0" id="event-start-date-tag">
                              {event ? handleValidDate(event.startat) + " to " + handleValidDate(event.endat) : ""}
                            </h6>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex align-items-center mb-2">
                        <div className="flex-shrink-0 me-3">
                          <i className="ri-map-pin-line text-muted fs-16"></i>
                        </div>
                        <div className="flex-grow-1">
                          <h6 className="d-block fw-semibold mb-0">
                            <span id="event-location-tag">
                              {event && event.location ? event.location : "No Location"}
                            </span>
                          </h6>
                        </div>
                      </div>
                      <div className="d-flex mb-3">
                        <div className="flex-shrink-0 me-3">
                          <i className="ri-discuss-line text-muted fs-16"></i>
                        </div>
                        <div className="flex-grow-1">
                          <h5>{event && event.permission_category !== undefined ? event.permission_category.name : ""}</h5>
                          <p className="d-block text-muted mb-0" id="event-description-tag" >
                            {event && event.description !== undefined ? event.description : "No Description"}
                          </p>
                          <p className="d-block text-muted mb-0" id="event-description-tag" >
                            {event && event.title}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex row mb-3">
                        <div className="flex-grow-1 col-lg-6">
                          {taskFiles.map((taskFile, i) => {
                            return (
                              <div key={i} className="border-bottom mb-3">
                                <div className="d-flex justify-content-between mb-3 align-items-center">
                                  <div className="me-2">
                                    <img src={taskFile.filename === "" ? logo : `${api.MEDIA_URL}/media/${taskFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="img-fluid" />
                                  </div>
                                </div>
                              </div>
                            );
                          })}
                          {event && event.path ? <img src={process.env.REACT_APP_API_URL + "/files/" + event.path.path} alt="" className="img-fluid" /> : ""}
                        </div>
                      </div>
                    </div>
                    <div className="event-form">
                      <div className="row">
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="client-field" className="form-label">Grup Usaha&nbsp; {clientLoading && (
                            <Spinner color="primary" size="sm">
                              Loading...
                            </Spinner>
                          )}
                          </Label>
                          <Select
                            name="client"
                            value={validation.values.client}
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            placeholder="Pilih Grup Usaha"
                            onChange={(e) => {
                              setCompanyList([]);
                              validation.setFieldValue("company", "");
                              validation.setFieldValue("client", e);
                              handleGetCompany(e.value);
                            }}
                            options={clientList}></Select>
                        </div>

                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="company-field" className="form-label">
                            Perusahaan&nbsp; {companyLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="company"
                            value={validation.values.company}
                            placeholder="Pilih Perusahaan"
                            isDisabled={userType === "admin" || userType === "client" ? false : true}
                            onChange={(e) => {
                              validation.setFieldValue("company", e);
                              handleGetEmployee(e.value);
                            }}
                            options={companyList}></Select>
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label htmlFor="employee-field" className="form-label">Karyawan <span className="text-danger">*</span>&nbsp;
                            {employeeLoading && (
                              <Spinner color="primary" size="sm">
                                Loading...
                              </Spinner>
                            )}
                          </Label>
                          <Select
                            name="employee"
                            value={validation.values.employee}
                            placeholder="Pilih Karyawan"
                            isDisabled={userType === "admin" || userType === "client" || (userRole && userRole.split(",").indexOf("approvePermissionStaff") < 0) ? false : true}
                            onChange={(e) => {
                              validation.setFieldValue("oldposition", e.position);
                              validation.setFieldValue("employee", e);
                            }}
                            options={employeeList}></Select>
                          {validation.touched.employee && validation.errors.employee ? (
                            <p className="invalid-feedback d-block" type="invalid">
                              {validation.errors.employee}
                            </p>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-6">
                          <Label className="form-label">Type</Label>
                          <Select name="type"
                            value={validation.values.type}
                            placeholder="Isi Type"
                            onChange={(e) => { validation.setFieldValue("type", e); }}
                            options={eventList}></Select>
                          {validation.touched.type && validation.errors.type ? (
                            <small className="text-danger" type="invalid">{validation.errors.type}</small>
                          ) : null}
                        </div>
                      </div>

                      <div className={"row"}>
                        <div className="mb-3 col-lg-6">
                          <Label className="form-label">Nama Acara</Label>
                          <Input
                            className={"form-control d-block"}
                            placeholder="Isi Nama Acara"
                            type="text"
                            name="name"
                            id="event-title"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.name} />
                          {validation.touched.name && validation.errors.name ? (
                            <small className="text-danger" type="invalid">{validation.errors.name}</small>
                          ) : null}
                        </div>
                        <div className="mb-3 col-lg-3">
                          <Label>Tanggal Mulai</Label>
                          <div className={"input-group"}>
                            <Flatpickr name="startat" className="form-control" placeholder="Tgl Mulai"
                              options={{ enableTime: true, time_24hr: true, altInput: true, altFormat: "Y/m/d H:i", dateFormat: "Y/m/d H:i", }}
                              value={validation.values.startat ?? ""}
                              onChange={(obj, str) => { validation.setFieldValue("startat", str) }} />
                            {validation.touched.startat && validation.errors.startat ? (
                              <small className="text-danger" type="invalid">{validation.errors.startat}</small>
                            ) : null}
                            <span className="input-group-text">
                              <i className="ri-calendar-event-line"></i>
                            </span>
                          </div>
                        </div>
                        <div className="mb-3 col-lg-3">
                          <Label>Tanggal Berakhir</Label>
                          <div className={"input-group"}>
                            <Flatpickr name="endat" className="form-control" placeholder="Tgl Berakhir"
                              options={{ enableTime: true, time_24hr: true, altInput: true, altFormat: "Y/m/d H:i", dateFormat: "Y/m/d H:i", }}
                              value={validation.values.endat ?? ""}
                              onChange={(obj, str) => { validation.setFieldValue("endat", str) }} />
                            {validation.touched.endat && validation.errors.endat ? (
                              <small className="text-danger" type="invalid">{validation.errors.endat}</small>
                            ) : null}
                            <span className="input-group-text">
                              <i className="ri-calendar-event-line"></i>
                            </span>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="mb-3 col-lg-12">
                          <Label htmlFor="event-location">Lokasi</Label>
                          <Input type="text" className={"form-control d-block"}
                            name="location"
                            id="event-location"
                            placeholder="Isi Lokasi"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.location ?? ""} />
                          {validation.touched.location && validation.errors.location ? (
                            <FormFeedback type="invalid">{validation.errors.location}</FormFeedback>
                          ) : null}
                        </div>
                        <div className="col-lg-12 mb-3">
                          <div className="mb-3 d-flex justify-content-between">
                            <Label htmlFor="taskFiles" className="form-label me-3">
                              Berkas Izin
                            </Label>
                            <button
                              type="button"
                              className="btn btn-sm btn-label btn-soft-success"
                              onClick={() => {
                                toggleMedia();
                              }}>
                              <i className="ri-file-cloud-fill label-icon align-middle fs-16 me-1"></i> Media
                            </button>
                          </div>
                          {taskFiles.map((taskFile, i) => {
                            if (taskFile.isDeleted) {
                              return null;
                            } else {
                              return (
                                <div key={i} className="border-bottom mb-3">
                                  <div className="d-flex justify-content-between mb-3 align-items-center">
                                    <div className="me-2">
                                      <img src={taskFile.filename === "" ? logo : `${api.MEDIA_URL}/media/${taskFile.filename}`} alt="" data-dz-thumbnail="" height="30" className="avatar-sm rounded bg-light" />
                                    </div>

                                    <div className="text-truncate">{taskFile.filename}</div>
                                    <div>
                                      <Link
                                        to="#"
                                        className={"btn-icon btn btn-sm btn-soft-danger remove-item-btn mx-2"}
                                        onClick={(e) => {
                                          handleDeleteFile(taskFile);
                                        }}>
                                        <i className="ri-delete-bin-line fs-15 text-danger"></i>
                                      </Link>
                                    </div>
                                  </div>
                                </div>
                              );
                            }
                          })}
                        </div>
                      </div>
                      <div className="mb-3">
                        <Label className="form-label">Keterangan</Label>
                        <textarea
                          className={"form-control d-block"}
                          id="event-description"
                          name="description"
                          placeholder="Isi Keterangan"
                          rows="3"
                          onChange={validation.handleChange}
                          onBlur={validation.handleBlur}
                          value={validation.values.description}></textarea>
                        {validation.touched.description && validation.errors.description ? (
                          <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                        ) : null}
                      </div>

                    </div>
                    {!!isEdit && !isTask && (
                      <div className="hstack gap-2 position-absolute justify-content-start">
                        <button type="button" className="btn btn-soft-danger" id="btn-delete-event" onClick={() => setDeleteModal(true)}>
                          <i className="ri-close-line align-bottom"></i> Delete
                        </button>
                        <Link to="#" id="edit-event-btn"
                          className={isShowEventForm ? 'd-none btn btn btn-soft-info' : 'd-block btn btn btn-soft-info'}
                          onClick={(e) => {
                            e.preventDefault();
                            submitOtherEvent();
                            setIsShowEventForm(true);
                            return false;
                          }}><i className="ri-edit-box-line align-bottom"></i> Show Form & Edit</Link>
                        {event.permission_category.type !== "general" ? (
                          event.canApprove &&
                          <button type="button"
                            className={isShowEventForm ? 'd-none btn btn-success' : 'd-block btn btn-soft-success'}
                            onClick={() => setApproveModal(true)}>
                            <i className="ri-checkbox-circle-line align-bottom"></i> Approve
                          </button>) : null}
                      </div>)}
                    <div className="hstack gap-2 justify-content-end"><p>&nbsp;</p>
                      <button type="submit" id="btn-save-event"
                        className={(!!isEdit && !isShowEventForm) ? 'd-none btn btn-success' : 'd-block btn btn-success'}>
                        {!!isEdit ? "Edit Event" : "Tambah Acara"}
                      </button>

                    </div>
                  </Form>
                </ModalBody>
              </Modal>

              <Modal isOpen={modalFull} id="event-modal" centered size="xl">
                <ModalHeader toggle={toggleFull} tag="h5" className="p-3 bg-soft-info modal-title">
                  PROGRESS
                </ModalHeader>
                <ModalBody>
                  <CardBody className="pt-4 ps-4 pe-4">
                    <Row className="mb-4">
                      <div className="col-lg-5">
                        {civilBudgetList && civilBudgetList.map((obj, i) => {
                          return (
                            <div key={i} className={"mb-3"}>
                              <p className="fw-semibold fs-14 text-uppercase m-1">{obj.category}</p>
                              <div className={"pe-3 ps-3 row"}>
                                {(obj.data || []).map((o, idx) => {
                                  let ischecked = false;
                                  if (info.checked_progress ? (info.checked_progress.split(",").find(x => x === o.cvld_account.id.toString()) ? true : false) : false) {
                                    ischecked = true;
                                  }
                                  return (
                                    <div key={idx} className="hstack gap 2 mb-2">
                                      <em className="avatar-xs rounded-circle" style={{ background: o.cvld_account.color, width: "20px", height: "18px", display: "block", float: "left" }}>&nbsp;</em>
                                      <div className="ms-2">
                                        <Label className={ischecked ? "form-check-label fw-semibold fs-12 text-uppercase" : "form-check-label fs-12 text-uppercase text-muted"}>
                                          <i className={ischecked ? "mt-2 fs-14 ri-check-line fw-semibold text-success me-1" : "mt-2 fs-14 ri-close-line me-1"}></i> {o.cvld_account.name}
                                        </Label>
                                      </div>
                                    </div>)
                                })}

                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div className="col-lg-7">
                        <h4 className="card-title mb-4 flex-grow-1">
                          History progress &nbsp;
                          {civilProgressionLoading && (
                            <>
                              <Spinner color="primary" type="grow" size={"sm"}>
                                Loading...
                              </Spinner>
                              &nbsp;
                              <Spinner color="success" type="grow" size={"sm"}>
                                Loading...
                              </Spinner>
                              &nbsp;
                            </>)}
                        </h4>
                        <div className="accordionflush">
                          {(civilProgressions || []).map((item, idx) => {
                            return (
                              <div key={idx} className="accordion-item border-0">
                                <div className="accordion-header">
                                  <div className="accordion-button p-2 shadow-none" id="headingOne">
                                    <div className="d-flex">
                                      <div className="flex-shrink-0">
                                        {item.cvlp_createdby && item.cvlp_createdby.user_image && item.cvlp_createdby.user_image.path ? (
                                          <img src={process.env.REACT_APP_API_URL + "/files/" + item.cvlp_createdby.user_image.path} alt="" className="rounded-circle avatar-xs" />
                                        ) : (
                                          <div className="flex-shrink-0 avatar-xs">
                                            <div className="avatar-title bg-soft-success text-success rounded-circle fs-13">{item.cvlp_createdby.name.charAt(0)}</div>
                                          </div>
                                        )}
                                      </div>
                                      <div className="flex-grow-1 ms-3">
                                        <h6 className="fs-14 mb-1">{item.cvlp_createdby.name}</h6>
                                        <p className="fw-normal text-muted mb-1">Memperbarui progress pembangunan dengan catatan:</p>
                                        <p className="fw-normal mb-1">{item.description || "-"}</p>
                                        <small className="text-muted"><span className="text-dark">{handleValidDate(item.createdat)}</span> {moment.utc(item.createdat).local().fromNow()}</small>
                                        <div className="row mt-3">
                                          {item.cvlp_file.map((f, i) => {
                                            return (
                                              <div key={i} className="col-lg-4" >
                                                <div className="position-relative d-inline-block mx-auto">
                                                  <ModalImage showRotate={true}
                                                    small={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}-w-50`}
                                                    large={f.filename === "" ? logo : `${api.MEDIA_URL}/media/${f.filename}`}
                                                    alt={info.name}
                                                    className="img-thumbnail avatar-lg img-thumbnail user-profile-image" />
                                                </div>
                                              </div>
                                            );
                                          })}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            )
                          }
                          )}
                        </div>
                      </div>
                    </Row>
                  </CardBody>

                </ModalBody>å
              </Modal>
              <ModalInputFile onSelect={handleSelectFile} loading={loading} modal={modalMedia} toggle={toggleMedia} />
            </Col>
          </Row>
        </Container>
        <Card id="dashboard-custom-tooltip" className="border">
          <CardBody className={info && info.weight ? "" : "d-none"}>
            <div className="d-flex align-items-center mb-3">
              <div className="avatar-md me-3 flex-shrink-0">
                <div className="avatar-title bg-soft-info rounded">
                  <img src={info.image} alt="" className="avatar-md" />
                </div>
              </div>
              <div className="flex-grow-1">
                <h5 className="fs-15 fw-bold mb-1">{info && info.name}</h5>
                <div className="mb-1">Bobot Tercapai <span className="fw-semibold">{info.weight ? info.weight : 0} %</span></div>
                <div className="mb-1" style={{ clear: "both" }}><em className="avatar-xs" style={{ background: info.color, width: "22px", height: "22px", display: "block", float: "left", marginRight: "5px" }}>&nbsp;</em> {info.progress}</div>
              </div>
            </div>
          </CardBody>
        </Card>
        
        <Card id="siteplan" className="d-none" style={{ position: "fixed", left: "0", top:"0", right:"0", bottom:"0", zIndex:1050, width: "100%", height:"100%" }}>
          <CardHeader className="border-0 align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">SITEPLAN</h4>
            <button className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle shadow-none" onClick={() => {
              document.getElementById("siteplan").classList.add("d-none");
            }}>
              <i className='ri-close-circle-fill fs-22' ></i>
            </button>
          </CardHeader>
          <CardBody className="pt-0" style={{overflow:"scroll"}}>

            <div>{svg && parse(svg)}</div>
          </CardBody>
        </Card>
      </div>
    </React.Fragment >
  );
};

Calender.propTypes = {
  events: PropTypes.any,
  categories: PropTypes.array,
  className: PropTypes.string,
  onGetEvents: PropTypes.func,
  onAddNewEvent: PropTypes.func,
  onUpdateEvent: PropTypes.func,
  onDeleteEvent: PropTypes.func,
  onGetCategories: PropTypes.func,
};

export default Calender;
